import React from 'react';

const NotFound: React.FunctionComponent = () => <h2>404</h2>;

export default NotFound;
